var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import H5 from './H5';
import Paragraph from './Paragraph';
import { FONT } from '../../constants';

var Type = function Type(_a) {
  var _b = _a.children,
      children = _b === void 0 ? null : _b,
      _c = _a.renderAs,
      renderAs = _c === void 0 ? 'span' : _c,
      _d = _a.size,
      size = _d === void 0 ? 'regular' : _d,
      className = _a.className;
  var TypeComponent = renderAs;
  return jsx(TypeComponent, {
    css: __assign({
      fontFamily: FONT.family
    }, FONT.sizes[size]),
    className: className
  }, children);
};

Type.H1 = H1;
Type.H2 = H2;
Type.H3 = H3;
Type.H4 = H4;
Type.H5 = H5;
Type.Paragraph = Paragraph;
export default Type;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Type/index.js
// module id = 118
// module chunks = 0